import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataTable } from "../../components/organisms/DataTable";
import { HorarioCard } from "./HorarioCard";
import { paginacion } from "../../utils/paginacion/paginacion";
import { eliminarHorario } from "../../services/horario.service";
import {
  showDeletedAlert,
  showErrorAlert,
  showQuestionDeleteAlert,
  showUpdateAlert,
} from "../../components/molecules/ShowAlert";

const HORARIOS_POR_PAGINA = 15;

export const HorarioList = ({ horarios = [], onRefresh }) => {
  const [paginaActual, setPaginaActual] = useState(1);
  const [busqueda, setBusqueda] = useState("");
  const navigate = useNavigate();

  const handleDeleteHorario = async (idHorario) => {
    showQuestionDeleteAlert({
      callback: async (result) => {
        if (result.isConfirmed) {
          try {
            await eliminarHorario(idHorario);
            showDeletedAlert({ callback: () => onRefresh?.() });
          } catch (error) {
            console.error("Error al eliminar horario:", error);
            showErrorAlert();
          }
        }
      },
    });
  };

  const handleEditHorario = (idHorario) => {
    showUpdateAlert({
      callback: () => navigate(`/horarios/actualizar/${idHorario}`),
    });
  };

  const horariosFiltrados = horarios.filter(({ dia, horaInicio, horaFin }) => {
    const texto = busqueda.toLowerCase();
    return (
      dia?.nombre?.toLowerCase().includes(texto) ||
      horaInicio?.toLowerCase().includes(texto) ||
      horaFin?.toLowerCase().includes(texto)
    );
  });

  const {
    objetosEnPagina: horariosEnPagina,
    paginas,
    paginaInicial,
    paginaFinal,
  } = paginacion(paginaActual, horariosFiltrados, HORARIOS_POR_PAGINA);

  const columnas = ["#", "Hora inicio", "Hora fin", "Día", "Opciones"];

  return (
    <section className="px-4 pb-10 max-w-6xl mx-auto">
      {/* Filtro y botón */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 my-4">
        <input
          type="text"
          placeholder="Buscar por día, hora inicio o fin..."
          value={busqueda}
          onChange={(e) => {
            setBusqueda(e.target.value);
            setPaginaActual(1);
          }}
          className="border border-gray-300 rounded px-4 py-2 w-full sm:max-w-md"
        />

        <button
          onClick={() => navigate("/horarios/registrar")}
          className="bg-theme-yellow hover:bg-yellow-500 text-white font-semibold px-6 py-2 rounded shadow"
        >
          + Nuevo
        </button>
      </div>

      <DataTable
        columnas={columnas}
        paginas={paginas}
        paginaInicial={paginaInicial}
        paginaFinal={paginaFinal}
        paginaActual={paginaActual}
        setPaginaActual={setPaginaActual}
      >
        {horariosEnPagina.length > 0 ? (
          horariosEnPagina.map((horario, index) => (
            <HorarioCard
              key={horario?.idHorario || index}
              horario={horario}
              index={(paginaActual - 1) * HORARIOS_POR_PAGINA + index + 1}
              onDelete={handleDeleteHorario}
              onEdit={handleEditHorario}
            />
          ))
        ) : (
          <tr>
            <td colSpan={columnas.length} className="text-center py-4 text-gray-500">
              No se encontraron horarios.
            </td>
          </tr>
        )}
      </DataTable>
    </section>
  );
};
